







































































































































































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import {QueryMaterials,QuerySysDic} from '../../../api/material'
import {QuerySupplier} from '../../../api/basicDictionary'
import {EditStockActionDetail,GetQueryStockActionDetailList,QueryStockBatchList,} from '../../../api/storehouse'
import util from '../../../lib/util'
import u from 'underscore'
@Component
export default class extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    @Prop({type:Number,default:1}) actionType:number;
    form:any = {
        itemType:null,
        actionType:this.actionType,
        receiptNo:Date.now(),
        supplierId:null,
        deptId:null,
        stockActionDetail:[],
    }
    itemform:object = {
        itemId:null,
        itemName:null,
        quantity:null,
        unit:null,
        batchNo:null,
        validityPeriod:null,
        purchasePrice:null,
        batchPurchasePrice:null,
        nowQuantity:null,
        checkQuantity:null,
        breakageReasonId:null,
        breakageReasonName:null,
        isSet:true,
        isNew:true
    }
    tableData:any = []
    sel:any = null

    //操作类型
    actionTypeOptions:any = [
        {value:1,text:'入库'},
        {value:2,text:'出库'},
        {value:3,text:'报损'},
        {value:4,text:'盘点'},
    ]
    getactionName(){
        return this.actionTypeOptions.find((item:any)=>{return item.value == this.form.actionType}).text
    }
    //按钮状态
    actionStatus = false
    itemOptions:any = []
    goodsTypeOptions:any = []
    supplierOptions:any = []
    tenantOptions:any = []
    breakOptions:any = []
    batchNoOptions:any = []
    //批次号内数量的限制
    maxQuantity:number = 9999
    itemChange(val){
        let item = this.itemOptions.find((v:any)=>{return (this.actionType!=1?v.itemId:v.id)==val})
        if(this.actionType!=1){
            this.batchNoOptions = item.batchNoArr
            this.sel.itemName = item.materialName
            this.sel.batchNo = item.batchNoArr[0].batchNo
            this.sel.unit = item.batchNoArr[0].unitId
            this.sel.unitName = item.batchNoArr[0].unitName
            this.sel.quantity = item.batchNoArr[0].quantity
            this.maxQuantity = item.batchNoArr[0].quantity
            this.sel.purchasePrice = item.batchNoArr[0].price
            this.sel.batchPurchasePrice = item.batchNoArr[0].price*item.batchNoArr[0].quantity
            
        }else{
            this.sel.unit = item.unit
            this.sel.unitName = item.unitName
            this.sel.itemName = item.name
        }
    }
    breakChange(val){
        let item = this.breakOptions.find((v:any)=>{return v.id==val})
        this.sel.breakageReasonName = item.typeName
    }
    batchNoChange(val){
        let item = this.batchNoOptions.find((v:any)=>{return v.batchNo==val})
        this.sel.quantity = item.quantity
        this.maxQuantity = item.quantity
        this.sel.purchasePrice = item.price
        this.sel.batchPurchasePrice = item.price*item.quantity
        this.sel.unitName = item.unitName
        this.sel.unit = item.unitId
    }
    itemLoading = false
    async itemRemoteMethod(query){
        if (query !== '') {
            this.itemLoading = true;
            let res;
            if(this.actionType!=1){
                res = await QueryStockBatchList({materialName:query,itemType:this.form.itemType})
                //根据药品分组，拿到批次号列表
                let group_obj= u.groupBy(res.data,function(value, key, list:any){return list[key].materialName})
                console.log(group_obj)
                let list = [];
                for (const key in group_obj) {
                    const element = group_obj[key];
                    //去掉库存为0的项目
                    if(element[0].quantity!==0)
                    list.push({
                        ...element[0],
                        id:element[0].itemId,
                        name:element[0].materialName,
                        batchNoArr:element,
                    })
                }
                this.itemOptions = list;
                console.log(this.itemOptions)
            }else{
                res = await QueryMaterials({status:true,pageSize:10000,page:1,materialName:query,type:this.form.itemType})
                this.itemOptions = res.data.items
            }

            this.itemLoading = false;
        } else {
            this.itemOptions = [];
        }
    }
    addrow() {
        if(!this.form.itemType){
            this.$message.warning('请先选择物资类型');
            return false
        }
        let j = Object.assign({},this.itemform)
        this.tableData.push(j);
        this.sel = JSON.parse(JSON.stringify(j));
        this.actionStatus = true
        this.itemOptions = []
    }
    remove(row,index){
        if(row.isSet){
            this.actionStatus = false
        }
        this.tableData.splice(index, 1);
    }
    //修改
    pwdChange(row, index, cg) {
        //是否是取消操作
        if (!cg) {
            this.actionStatus = false
            return row.isSet = !row.isSet;
        }
        //提交数据
        if (row.isSet) {
            if(!this.sel.itemId || !this.sel.quantity || !this.sel.batchNo){
                this.$message.warning('请填写完整');
                return false
            }
            if(this.actionType==3 && !this.sel.breakageReasonId){
                this.$message.warning('请填写完整');
                return false
            }
            if(this.actionType==4 && !this.sel.nowQuantity){
                this.$message.warning('请填写完整');
                return false
            }
            this.$message.success('保存成功');
            this.sel.isSet = false
            //非新增项标识
            this.sel.isNew = false
            this.$set(this.tableData,index,this.sel)
            console.log(this.tableData)
            this.actionStatus = false
        } else {
            this.sel = JSON.parse(JSON.stringify(row));
            row.isSet = true;
            this.actionStatus = true
            this.itemOptions = [{id:this.sel.itemId,name:this.sel.itemName}]
        }
    }
    
    created(){
        this.getSelects()
        console.log(this.data)
        if(this.data){
            this.getData()
            this.form.itemType  = this.data.itemType
            this.form.supplierId  = this.data.supplierId
            this.form.receiptNo = this.data.receiptNo
            this.form.deptId = this.data.deptId
            this.form.actionId = this.data.actionId
        }
    }
    //
    async getData(){
        let res = await GetQueryStockActionDetailList({ActionId:this.data.actionId})
        res.data.forEach((item:any) => {
            item.isSet = false
            item.isNew = false
        });
        this.tableData = res.data.map((item:any)=>{
            item.itemName = item.materialName
            item.unit = item.unitId
            item.batchPurchasePrice = item.quantity*item.purchasePrice
            item.validityPeriod = util.formatTime(item.validityPeriod)
            item.breakageReasonName = item.breakageReason
            if(this.actionType==4){
                item.checkQuantity = item.nowQuantity - item.quantity
            }
            return item;
        })
    }
    //获取下拉框
    async getSelects(){
        // this.itemOptions = (await QueryMaterials({status:true,pageSize:10000,page:1})).data
        this.breakOptions = (await this.QuerySysDic({dataType:6,typeName:'',status:true})).data
        this.goodsTypeOptions = (await QuerySysDic({dataType:1,status:true,typeName:''})).data
        this.supplierOptions = (await QuerySupplier({queryString:'',pageSize:10000,page:1})).data.items
        this.tenantOptions = (await this.QueryTenant({queryString:'',pageSize:10000,page:1})).data
    }
    async save(){
        if(this.actionStatus){
            this.$message.warning('请先保存列表')
            return false
        }
        if(this.tableData.length==0){
            this.$message.warning('列表不能为空')
            return false
        }
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                this.form.stockActionDetail = this.tableData
                let res = await EditStockActionDetail(this.form)
                if(res.code==2000){
                    this.$emit('save-success')
                    this.$emit('input',false);
                }
            }
        })
    }
    cancel(){
        (this.$refs.form as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    formRule={
        supplierId:[{required: true,message:'不能为空',trigger: 'blur'}],
        deptId:[{required: true,message:'不能为空',trigger: 'blur'}],
        itemType:[{required:true,message:'不能为空',trigger: 'blur'}],
        receiptNo:[{required:true,message:'不能为空',trigger: 'blur'}],
    }
}
